import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── PartnerIQ ───────────────────────────────────────────────────────────────────
// Persona: Channel / Alliances
// Data sources: See constants/modules.js

const KPIs = [
  { label: "Partner-Sourced ARR", value: "$1.1M", delta: "14% of total", color: "#059669" },
  { label: "Co-Sell Pipeline", value: "$3.4M", delta: "Active", color: "#059669" },
  { label: "Partner Win Rate", value: "71%", delta: "+6pts vs direct", color: "#059669" },
  { label: "Active Partners", value: "42", delta: "Tier 1 & 2", color: "#059669" },
  { label: "Enablement Done", value: "64%", delta: "of active partners", color: "#d97706" },
  { label: "Partner CAC", value: "$3,800", delta: "41% < direct", color: "#059669" }
];
const CHART_DATA = [
  {
    "partner": "Tier 1 (x6)",
    "sourced": 680,
    "influenced": 1200
  },
  {
    "partner": "Tier 2 (x18)",
    "sourced": 290,
    "influenced": 840
  },
  {
    "partner": "Tier 3 (x18)",
    "sourced": 130,
    "influenced": 220
  }
];

export default function PartnerIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Partner Revenue by Tier ($K)</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="partner" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="sourced" fill="#be185d" radius={[4,4,0,0]} />
          <Bar dataKey="influenced" fill="#f472b6" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>6 Tier 1 partners generate 62% of all partner-sourced ARR. Concentration risk — top partner accounts for 28% of that alone.</p>
        </div>
      </div>
    </div>
  );
}
